declare namespace $ {

	type $mol_string_button__value_shm_service_dashboard_head_1 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_service_dashboard_head_2 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['title_save'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_service_dashboard_head_3 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_service_dashboard_head['title_save'] > ): ReturnType< $shm_service_dashboard_head['title_save'] >,
			keydown( next?: ReturnType< $shm_service_dashboard_head['title_keydown'] > ): ReturnType< $shm_service_dashboard_head['title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $mol_button_minor__title_shm_service_dashboard_head_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_service_dashboard_head_5 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__style_shm_service_dashboard_head_6 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_service_dashboard_head['edit_color'] >,
		})  & ReturnType< $mol_button_minor['style'] >
		,
		ReturnType< $mol_button_minor['style'] >
	>
	type $mol_button_minor__title_shm_service_dashboard_head_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_service_dashboard_head_8 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['view_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_service_dashboard_head_9 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['view'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__style_shm_service_dashboard_head_10 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_service_dashboard_head['view_color'] >,
		})  & ReturnType< $mol_button_minor['style'] >
		,
		ReturnType< $mol_button_minor['style'] >
	>
	type $mol_view__sub_shm_service_dashboard_head_11 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard_head['mode_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_service_dashboard_head extends $mol_view {
		title( next?: string ): string
		title_save( next?: any ): any
		title_keydown( next?: any ): any
		Title_edit( ): $mol_string_button
		edit( next?: any ): any
		edit_color( ): string
		Task_mode_edit( ): $mol_button_minor
		view_enabled( ): boolean
		view( next?: any ): any
		view_color( ): string
		Task_mode_view( ): $mol_button_minor
		mode_rows( ): readonly(any)[]
		Task_mode_controls( ): $mol_view
		menu( ): $mol_view | null
		view_visible( ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map